import React, { useState, useEffect } from 'react';
import { useFormikContext, getIn } from 'formik';

const PreferenceOrderPreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();
  const disabled = !sendSurvey || outOfDate;

  const currentAnswerText = getIn(values, `${fieldName}[answerText]`) || '';

  const [items, setItems] = useState(() => {
    const choices = (question.questionChoicesAttributes || [])
      .filter(c => !c._destroy);

    if (currentAnswerText) {
      const positionOrder = currentAnswerText.split(',').map(Number);
      return [...choices].sort((a, b) => {
        const indexA = positionOrder.indexOf(Number(a.position));
        const indexB = positionOrder.indexOf(Number(b.position));
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
    }
    return [...choices].sort((a, b) => a.position - b.position);
  });

  const [dragIndex, setDragIndex] = useState(null);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    if (!hasInteracted) {
      const choices = (question.questionChoicesAttributes || [])
        .filter(c => !c._destroy);

      if (currentAnswerText) {
        const positionOrder = currentAnswerText.split(',').map(Number);
        const sorted = [...choices].sort((a, b) => {
          const indexA = positionOrder.indexOf(Number(a.position));
          const indexB = positionOrder.indexOf(Number(b.position));
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
        setItems(sorted);
      } else {
        setItems([...choices].sort((a, b) => a.position - b.position));
      }
    }
  }, [currentAnswerText, question, hasInteracted]);

  useEffect(() => {
    if (hasInteracted) {
      const answer = items.map(c => c.position).join(',');
      setFieldValue(`${fieldName}[answerText]`, answer);
    }
  }, [items, fieldName, setFieldValue, hasInteracted]);

  const handleDragStart = index => {
    if (disabled) return;
    setDragIndex(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (dragIndex === null || dragIndex === index) return;
    const updated = [...items];
    const dragged = updated.splice(dragIndex, 1)[0];
    updated.splice(index, 0, dragged);
    setDragIndex(index);
    setItems(updated);
    setHasInteracted(true);
  };

  const handleDragEnd = () => {
    setDragIndex(null);
  };

  const getItemClass = index => {
    const classes = ['preference-order-item'];
    if (dragIndex === index) classes.push('dragging');
    if (disabled) classes.push('disabled');
    return classes.join(' ');
  };

  return (
    <div className="mt-2 preference-order-list">
      {items.map((choice, index) => (
        <div
          key={choice.id || choice.position}
          draggable={!disabled}
          onDragStart={() => handleDragStart(index)}
          onDragOver={e => handleDragOver(e, index)}
          onDragEnd={handleDragEnd}
          className={getItemClass(index)}
        >
          <span className="preference-order-handle">☰</span>
          {choice.label}
        </div>
      ))}
    </div>
  );
};

export default PreferenceOrderPreview;

